import React from "react";
import FoodProductionField from "./FoodProductionField";
import { thisBaseURL } from "../../utils/helper.js";

function FoodProduction({countryAnswers}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let commodityByQty = countryAnswers.answerKeyValues['top_commodity_production_by_quantity'];
	let commodityByQtyArr = [];
	if(commodityByQty){
		try {
			commodityByQtyArr = JSON.parse(commodityByQty);
		} catch (err) {
			console.log("FoodProduction :commodityByQty: " +err);
		}
	}
	let commodityByValue = countryAnswers.answerKeyValues['top_commodity_production_by_value'];
	let commodityByValArr = [];
	if(commodityByValue){
		try {
			commodityByValArr = JSON.parse(commodityByValue);
		} catch (err) {
			console.log("FoodProduction :commodityByValue: " +err);
		}
	}
	let commodityQtySourceRef = countryAnswers.answerKeyValues['top_commodity_production_by_quantity_sources'];
	let commodityQtyYear = countryAnswers.answerKeyValues['top_commodity_production_by_quantity_year'];
	let commodityQtyNotes = countryAnswers.answerKeyValues['top_commodity_production_by_quantity_notes'];
	let commodityQtyUnit = countryAnswers.answerKeyValues['top_commodity_production_by_quantity_unit'] || "Metric Tons";
	
	let commodityValSourceRef = countryAnswers.answerKeyValues['top_commodity_production_by_value_sources'];
	let commodityValYear = countryAnswers.answerKeyValues['top_commodity_production_by_value_year'];
	let commodityValNotes = countryAnswers.answerKeyValues['top_commodity_production_by_value_notes'];

	return(<div className="question-grouping" id="food_production">
				<h2>Food Production</h2>
				<div className="clearfix">
					<div style={{float:"left", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Commodities Produced by Quantity
								{commodityQtyYear ? 
								<small>&nbsp;({commodityQtyYear})</small>
								: ""}
								{commodityQtySourceRef && commodityQtySourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+commodityQtySourceRef}>{commodityQtySourceRef}</a></small>
								:""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Commodity</th>
										<th width="25%">Quantity ({commodityQtyUnit})</th>
									</tr>
								</thead>
								<tbody>
									<FoodProductionField commodityArr={{commodityByQtyArr}} by={"Qty"} />
								</tbody>
							</table>
							{commodityQtyNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{commodityQtyNotes}</em>
							</p>
							: ""}
						</div>
					</div>
					<div style={{float:"right", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Commodities Produced by Value
								{commodityValYear ? 
								<small>&nbsp;({commodityValYear})</small>
								: ""}
								{commodityValSourceRef && commodityValSourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+commodityValSourceRef}>{commodityValSourceRef}</a></small>
								: ""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Commodity</th>
										<th width="25%">Value (1000 Int $)</th>
									</tr>
								</thead>
								<tbody>
									<FoodProductionField commodityArr={{commodityByValArr}} by={"Val"}/>
								</tbody>
							</table>
							{commodityValNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{commodityValNotes}</em>
							</p>
							: ""}
						</div>
					</div>
				</div>
			</div>);
}
export default FoodProduction;